export class AssertError extends Error {
}
export function assert(cond) {
    if (!cond)
        throw new AssertError();
}
export class ExplicitRecoverError extends Error {
}
